import React from "react";
import SVGElement from "./SVGElement";

const S8 = () => {
  return (
    <SVGElement
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="57"
      viewBox="0 0 64 57"
    >
      <g fill="none">
        <path
          fill="#5AB963"
          d="M58.375,0.05825 L5.625,0.05825 C2.523375,0.05825 0,2.581625 0,5.68325 L0,28.18325 C0,31.284875 2.523375,33.80825 5.625,33.80825 C7.55225,33.80825 56.446625,33.80825 58.375,33.80825 C61.476625,33.80825 64,31.284875 64,28.18325 L64,5.68325 C64,2.581625 61.476625,0.05825 58.375,0.05825 Z M11.9015,30.05825 L12.849875,26.264375 C12.978875,26.2925 13.1125,26.30825 13.25,26.30825 L50.75,26.30825 C50.8875,26.30825 51.021,26.2925 51.150125,26.264375 L52.098625,30.05825 L11.9015,30.05825 Z M13.7765,22.55825 L14.714,18.80825 L49.286125,18.80825 L50.223625,22.55825 L13.7765,22.55825 Z M60.25,28.18325 C60.25,29.217125 59.408875,30.05825 58.375,30.05825 L55.964,30.05825 L52.569,16.4785 C52.360375,15.643875 51.610375,15.05825 50.75,15.05825 L13.25,15.05825 C12.389625,15.05825 11.639625,15.643875 11.431,16.4785 L8.036,30.05825 L5.625,30.05825 C4.591125,30.05825 3.75,29.217125 3.75,28.18325 L3.75,5.68325 C3.75,4.649375 4.591125,3.80825 5.625,3.80825 L58.375,3.80825 C59.408875,3.80825 60.25,4.649375 60.25,5.68325 L60.25,28.18325 Z"
        />
        <circle cx="39.5" cy="9.434" r="1.875" fill="#000" />
        <circle cx="47" cy="9.434" r="1.875" fill="#000" />
      </g>
    </SVGElement>
  );
};

export default S8;
